module.exports = __webpack_public_path__ + "static/media/stofferingen-15.0f53c3a3.jpg";